module.exports = __webpack_public_path__ + "img/89.9.TU.d3933781.png";